
import { useCallback, useTransition } from "react";
import { useRecoilState_TRANSITION_SUPPORT_UNSTABLE } from "recoil";

import { drawerState } from "@/states/used-cars/new-filters.state";

export const useFiltersModal = () => {
  const [isDrawerOpen, setIsDrawerOpen] =
    useRecoilState_TRANSITION_SUPPORT_UNSTABLE(drawerState);
  
  const [_isPending, startTransition] = useTransition();

  const openFiltersModal = useCallback(() => {
    startTransition(() => {
      setIsDrawerOpen(true);
    });
  }, [])

  const closeFiltersModal = () => {
    startTransition(() => {
      setIsDrawerOpen(false);
    });
  };

  return {
    isDrawerOpen,
    openFiltersModal,
    closeFiltersModal
  };
}